// extracted by mini-css-extract-plugin
module.exports = {"legend":"styles_legend___7xqe","item":"styles_item__31eRu","colour":"styles_colour__1SK2k","label":"styles_label__2k1Jb"};